import { Button as MuiButton } from '@mui/material';
import type { ButtonProps as MuiButtonProps } from '@mui/material/Button';

export type ButtonProps = MuiButtonProps & {
  href?: string;
  target?: string;
};

export type ButtonVariant = NonNullable<MuiButtonProps['variant']>;
export type ButtonColor = NonNullable<MuiButtonProps['color']>;
export type ButtonSize = NonNullable<MuiButtonProps['size']>;

export const BUTTON_VARIANTS = {
  text: 'text',
  outlined: 'outlined',
  contained: 'contained'
} as const satisfies Record<string, ButtonVariant>;

export const BUTTON_COLORS = {
  inherit: 'inherit',
  primary: 'primary',
  secondary: 'secondary',
  success: 'success',
  error: 'error',
  info: 'info',
  warning: 'warning'
} as const satisfies Record<string, ButtonColor>;

export const BUTTON_SIZES = {
  small: 'small',
  medium: 'medium',
  large: 'large'
} as const satisfies Record<string, ButtonSize>;

export const Button = ({ children, ...props }: Readonly<ButtonProps>) => (
  <MuiButton {...props}>{children}</MuiButton>
);
